import React, { Component } from 'react'
import { Switch, Route, withRouter } from "react-router-dom";
import Pendientes from './pendientes/Pendientes';
import Confirmacion from './confirmaciones/Confirmacion';
import Confirmaciones from './confirmaciones/Confirmaciones';
import Recepciones from './recepcion/Recepciones';
import { AuthContext } from "../../context/authContext";

class Recolecciones extends Component {
  constructor(props) {
    super(props);
    this.rutas = [
      { path: `${this.props.match.path}/Pendientes`, Componente: Pendientes, accion: 'show'},
      { path: `${this.props.match.path}/Confirmaciones`, Componente: Confirmaciones, accion: 'show' },
      { path: `${this.props.match.path}/Confirmacion`, Componente: Confirmacion, accion: 'show' },
      { path: `${this.props.match.path}/Recepciones`, Componente: Recepciones, accion: 'show' },
    ];
    this.state = {
      recursos: []
    };
  }

  componentDidMount() {
    const validResources = this.rutas
    this.setState({ recursos: validResources });
  }

  render() {
    return (
      <div style={{ padding: 10 }}>
        <Switch>
          {
            this.state.recursos.map((recurso, index) => (
              <Route key={`ruta-${index}`} path={recurso.path}>
                <recurso.Componente />
              </Route>)
            )
          }
        </Switch>
      </div>
    )
  }
}
Recolecciones.contextType = AuthContext;
export default withRouter(Recolecciones)